/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ModuleViewMore.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import ModuleEEViewMore from "./ModuleEEViewMore";
import CustomSearchFilterV2 from "../../../common/searchBar/CustomSearchFilterV2";
import ModuleSWMViewMore from "./ModuleSWMViewMore";

function ModuleViewMore({
  linkedComponent,
  setLinkedComponent,
  type,
  gap = "2rem",
}) {
  const [linkTableRows, setLinkTableRows] = useState([]);
  const [filteredTableRows, setFilteredTableRows] = useState([]);

  console.log("linkedComponent", linkedComponent);

  const getvalueByType = () => {
    switch (type) {
      case "EE":
        return {
          searchKey: ["assembly_number"],
          renderComponent: <ModuleEEViewMore linkTableRows={linkTableRows} />,
        };
      case "SWM":
        return {
          searchKey: [["name"]],
          renderComponent: <ModuleSWMViewMore linkTableRows={linkTableRows} />,
        };
      default:
        return {
          searchKey: [],
          renderComponent: <></>,
        };
    }
  };

  useEffect(() => {
    const alteredLinkedComponent =
      filteredTableRows?.map((item, index) => ({
        id: index + 1,
        column1: item,
        column2: item,
      })) || [];
    console.log("--alteredLinkedComponent---", alteredLinkedComponent);
    setLinkTableRows(alteredLinkedComponent);
  }, [filteredTableRows]);

  return (
    <Box
      sx={{
        width: "750px",
        display: "flex",
        flexDirection: "column",
        gap: gap,
      }}
    >
      <Box mb={1}>
        <CustomSearchFilterV2
          placeholder={"Search"}
          searchKeys={getvalueByType()?.searchKey || []}
          getDataOnSearch={(filteredData) => {
            setFilteredTableRows(filteredData);
          }}
          inputData={linkedComponent}
        />
      </Box>
      <Box>{getvalueByType().renderComponent}</Box>
    </Box>
  );
}

export default ModuleViewMore;
